'use client';

import { motion } from 'framer-motion';

export function WorldMapSection() {
  return (
    <section className="relative w-full bg-white px-4 py-20 dark:bg-slate-950 md:py-32">
      <div className="mx-auto max-w-7xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
        >
          <p className="mb-6 text-xl font-bold text-slate-900 dark:text-white md:text-4xl">
            Global Reach{' '}
            <span className="text-slate-400 dark:text-slate-600">
              {'Connectivity'.split('').map((word, idx) => (
                <motion.span
                  key={idx}
                  className="inline-block"
                  initial={{ x: -10, opacity: 0 }}
                  whileInView={{ x: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: idx * 0.04 }}
                >
                  {word}
                </motion.span>
              ))}
            </span>
          </p>
          <p className="mx-auto max-w-2xl text-base text-slate-600 dark:text-slate-400 md:text-lg">
            Build and scale your applications with global infrastructure. Connect users across continents with blazing-fast performance.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative mx-auto mt-16 aspect-video w-full max-w-4xl overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-100 to-slate-50 dark:border-slate-700 dark:from-slate-900 dark:to-slate-800"
        >
          <div className="flex h-full items-center justify-center">
            <div className="text-center">
              <div className="mb-4 text-4xl">🌍</div>
              <p className="text-slate-600 dark:text-slate-400">Interactive World Map</p>
              <p className="mt-2 text-sm text-slate-500 dark:text-slate-500">(WorldMap component placeholder)</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
